import React from 'react'
import { graphql } from 'gatsby'
import {
  mapEdgesToNodes,
  filterOutDocsWithoutSlugs,
} from '../lib/helpers'
import styled from 'styled-components'
import GraphQLErrorList from '../components/graphql-error-list'
import ArticlePreviewGrid from '../components/article-preview-grid'
import Cover from '../components/cover'
import SEO from '../components/seo'
import Toc from '../components/toc'
import Intro from '../components/intro'
import Layout from '../containers/layout'



export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: {regex: "/(drafts.|)siteSettings/"}) {
      title
      description
      keywords
    }

    articles: allSanityArticle(
      filter: {slug: {current: {ne: null}}}
    ) {
      edges {
        node {
          _type
          _id
          mainImage {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
          title
          _rawDescription
          slug {
            current
          }
        }
      }
    }

    quizes: allSanityQuiz(
      filter: {slug: {current: {ne: null}}}
    ) {
      edges {
        node {
          _id
          _type
          mainImage {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
          title
          _rawDescription
          slug {
            current
          }
        }
      }
    }

    standardQuizes: allSanityStandardQuiz(
      filter: {slug: {current: {ne: null}}}
    ) {
      edges {
        node {
          _id
          _type
          mainImage {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
          title
          _rawDescription
          slug {
            current
          }
        }
      }
    }

    recipes: allSanityRecipe(
      filter: {slug: {current: {ne: null}}}
    ) {
      edges {
        node {
          _id
          _type
          mainImage {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
          title
          _rawDescription
          slug {
            current
          }
        }
      }
    }

  }
`

const Index = styled.article`
`

const IndexPage = props => {
  const { data, errors } = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const site = (data || {}).site
  const articles = (data || {}).articles
    ? mapEdgesToNodes(data.articles)
      .filter(filterOutDocsWithoutSlugs)
    : []

  const quizes = (data || {}).quizes
    ? mapEdgesToNodes(data.quizes)
      .filter(filterOutDocsWithoutSlugs)
    : []

  const standardQuizes = (data || {}).quizes
    ? mapEdgesToNodes(data.standardQuizes)
      .filter(filterOutDocsWithoutSlugs)
    : []

  const recipes = (data || {}).recipes
    ? mapEdgesToNodes(data.recipes)
      .filter(filterOutDocsWithoutSlugs)
    : []

  const allContent = [...articles, ...recipes, ...standardQuizes, ...quizes];

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    )
  }


  return (
    <Layout scrollNav={true}>
      <Index>
        <SEO title={site.title} description={site.description} keywords={site.keywords} />
        <Cover />
        <Intro />
        <Toc allContent={allContent} />
      </Index>
    </Layout>
  )
}

export default IndexPage
